/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AllergenRecipeModal_allAllergen$ref: FragmentReference;
declare export opaque type AllergenRecipeModal_allAllergen$fragmentType: AllergenRecipeModal_allAllergen$ref;
export type AllergenRecipeModal_allAllergen = {|
  +edges: $ReadOnlyArray<?{|
    +node: ?{|
      +id: string,
      +name: string,
    |}
  |}>,
  +$refType: AllergenRecipeModal_allAllergen$ref,
|};
export type AllergenRecipeModal_allAllergen$data = AllergenRecipeModal_allAllergen;
export type AllergenRecipeModal_allAllergen$key = {
  +$data?: AllergenRecipeModal_allAllergen$data,
  +$fragmentRefs: AllergenRecipeModal_allAllergen$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllergenRecipeModal_allAllergen",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AllergenNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AllergenNode",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AllergenNodeConnection"
};
// prettier-ignore
(node/*: any*/).hash = 'd6cbb145065a75cc6330bc6fdbd3994e';

module.exports = node;
